/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AdditionalCategory
 */
export interface AdditionalCategory {
  /**
   *
   * @type {number}
   * @memberof AdditionalCategory
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof AdditionalCategory
   */
  name?: string
}

/**
 * Check if a given object implements the AdditionalCategory interface.
 */
export function instanceOfAdditionalCategory(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function AdditionalCategoryFromJSON(json: any): AdditionalCategory {
  return AdditionalCategoryFromJSONTyped(json, false)
}

export function AdditionalCategoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AdditionalCategory {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
  }
}

export function AdditionalCategoryToJSON(value?: AdditionalCategory | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
  }
}
